import { Navigate, Outlet, useParams } from 'react-router';
import { LoadingScreen } from '@/components/base';
import { useAuthContext } from '@/contexts/authContext';
import { User, UserRole } from '@/model/User.model';
import { publicRoutes } from '@/router/routes';

const checkPermission = (user: User, schoolId: string): boolean => {
  if (user.role === UserRole.Admin || user.role === UserRole.SchoolGroupAdmin) {
    return true;
  }

  if (user.role === UserRole.Instructor || user.role === UserRole.SchoolAdmin) {
    return user.schoolId === schoolId;
  }

  return false;
};

/**
 * SchoolAppRoot for checking authentication and authorization
 */
const SchoolAppRoot = () => {
  const { schoolId } = useParams();
  const { user, isLogin, isAuthenticating } = useAuthContext();

  if (isAuthenticating) {
    return <LoadingScreen />;
  }

  if (!isAuthenticating && !isLogin) {
    return <Navigate to={publicRoutes.Login.getRoute()} />;
  }

  if (user && schoolId && !checkPermission(user, schoolId)) {
    // TODO: redirect to unauthorized page or show unauthorized message
    alert(
      'You do not have a permission to access this page. Please make sure you entered a correct email and password'
    );
    return <Navigate to={publicRoutes.Login.getRoute()} />;
  }

  return <Outlet />;
};

export default SchoolAppRoot;
